<template>
<div class="chapter">
<div class="inner_page">
<h1 class="toc-title">Contents</h1>
<h2 class="toc-fm"><a id="page_v"><em class="italic"></em></a><a href="#/xhtml/University_Introduction">University Introduction</a></h2>
<h2 class="toc-fm1"><em class="italic"><a href="#/xhtml/About_the_Author"><em class="italic">About the Author</em></a></em></h2>
<h2 class="toc-fm2"><a href="#/xhtml/Introduction">Introduction</a></h2>
<h2 class="toc-ch"><a href="#/xhtml/Chapter01"><span class="spacet">1.</span>Beginnings</a></h2>
<h2 class="toc-ch"><a href="#/xhtml/Chapter02"><span class="spacet">2.</span>What Do We Mean by Imagination?</a></h2>
<h2 class="toc-ch"><span href="#/xhtml/Chapter03" title="Link target outside of Sample"><span class="spacet">3.</span>Assumptions</span></h2>
<h2 class="toc-ch"><span href="#/xhtml/Chapter04" title="Link target outside of Sample"><span class="spacet">4.</span>Literalism</span></h2>
<h2 class="toc-ch"><span href="#/xhtml/Chapter05" title="Link target outside of Sample"><span class="spacet">5.</span>Imagining Others</span></h2>
<h2 class="toc-ch"><span href="#/xhtml/Chapter06" title="Link target outside of Sample"><span class="spacet">6.</span>Imagining the Self</span></h2>
<h2 class="toc-ch"><span href="#/xhtml/Chapter07" title="Link target outside of Sample"><span class="spacet">7.</span>What About Reason?</span></h2>
<h2 class="toc-ch"><span href="#/xhtml/Chapter08" title="Link target outside of Sample"><span class="spacet">8.</span>Selling</span></h2>
<h2 class="toc-ch"><span href="#/xhtml/Chapter09" title="Link target outside of Sample"><span class="spacet">9.</span>Imagining God</span></h2>
<h2 class="toc-ch"><span href="#/xhtml/Chapter10" title="Link target outside of Sample"><span class="spacet1">10.</span> Parables</span></h2>
<h2 class="toc-ch"><span href="#/xhtml/Chapter11" title="Link target outside of Sample"><span class="spacet1">11.</span> Literalism Revisited</span></h2>
<h2 class="toc-ch"><span href="#/xhtml/Chapter12" title="Link target outside of Sample"><span class="spacet1">12.</span> Analogy</span></h2>
<h2 class="toc-ch"><span href="#/xhtml/Chapter13" title="Link target outside of Sample"><span class="spacet1">13.</span> Re-imagining</span></h2>
<h2 class="toc-ch"><span href="#/xhtml/Chapter14" title="Link target outside of Sample"><span class="spacet1">14.</span> Re-imagining God</span></h2>
<h2 class="toc-ch"><span href="#/xhtml/Chapter15" title="Link target outside of Sample"><span class="spacet1">15.</span> Implications</span></h2>
<h2 class="toc-bm1"><span href="#/xhtml/Notes" title="Link target outside of Sample">Notes</span></h2>
<a id="page_vi">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// toc.vue?5a8b5446